<h3 mat-dialog-title>Create codes</h3>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div mat-dialog-content class="content">
    <mat-form-field>
      <mat-label>Product SKUs</mat-label>
      <input type="text" matInput formControlName="productSkuId"
        [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">
            {{option.name}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (form.controls.productSkuId.invalid) {
        <mat-error>Please choose a product SKU</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Number of characters</mat-label>
      <input type="number" matInput placeholder="" formControlName="numberOfCharacters" [readonly]="true">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Exported format (Mask)</mat-label>
      <input type="text" required matInput placeholder="" formControlName="format"
        (keyup)="onFormatKeyUpEvent($event)">
      @if (form.controls.format.invalid) {
        <mat-error>Please enter a valid format. Format must be contains
        "*"</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Number of safeboxes to create</mat-label>
      <input type="number" required matInput formControlName="numberOfSafeBoxes" min="1" pattern="\d*">
      @if (form.controls.numberOfSafeBoxes.invalid && form.controls.numberOfSafeBoxes.errors?.['required']) {
        <mat-error
          >Please
          enter a valid Number of safeboxes to
        create</mat-error>
      }
      @if (form.controls.numberOfSafeBoxes.invalid && form.controls.numberOfSafeBoxes.errors?.['max']) {
        <mat-error
          >Maximum
        is {{ form.controls.numberOfSafeBoxes.errors?.['max'].max | number }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Tags</mat-label>
      <mat-chip-grid #chipGrid aria-label="Enter tags" [formControl]="tagsControl">
        @for (tag of tagList; track tag) {
          <mat-chip-row (removed)="remove(tag)" [aria-description]="'press enter to edit ' + tag">
            {{tag}}
            <button matChipRemove [attr.aria-label]="'remove ' + tag">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input placeholder="New tags..." [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)" />
      </mat-chip-grid>
      @if (form.controls.tags.invalid && form.controls.tags.errors?.['maxlengInvalid']) {
        <mat-error>Tags must be less than {{ form.controls.tags.errors?.['maxlengInvalid']  }} characters</mat-error>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions class="gap-8">
    <lib-button variant="stroked" type="button" (click)="onClose()">Close</lib-button>
    <lib-button type="submit" variant="raised" color="primary" [disabled]="!form.valid">Create</lib-button>
  </div>
</form>